(function() {
  const storageKey = 'cart-drawer-recommendations-collapsed';
  const eventListenersMap = new Map();

  function initRecommendations() {
    const carousel = document.querySelector('.cart-drawer-recommendations__grid');
    
    if (!carousel) return;

    const closeBtn = document.querySelector('.cart-drawer-recommendations__close-btn');
    const container = document.querySelector('.cart-drawer-recommendations__container');
    const prevBtn = document.querySelector('.cart-drawer-recommendations__nav-button--prev');
    const nextBtn = document.querySelector('.cart-drawer-recommendations__nav-button--next');

    if (closeBtn && eventListenersMap.has('closeBtn')) {
      const oldListener = eventListenersMap.get('closeBtn');
      closeBtn.removeEventListener('click', oldListener);
    }
    if (prevBtn && eventListenersMap.has('prevBtn')) {
      const oldListener = eventListenersMap.get('prevBtn');
      prevBtn.removeEventListener('click', oldListener);
    }
    if (nextBtn && eventListenersMap.has('nextBtn')) {
      const oldListener = eventListenersMap.get('nextBtn');
      nextBtn.removeEventListener('click', oldListener);
    }
    if (carousel && eventListenersMap.has('carouselTouchstart')) {
      const oldListener = eventListenersMap.get('carouselTouchstart');
      carousel.removeEventListener('touchstart', oldListener);
    }
    if (carousel && eventListenersMap.has('carouselTouchend')) {
      const oldListener = eventListenersMap.get('carouselTouchend');
      carousel.removeEventListener('touchend', oldListener);
    }

    let startX = 0;
    let endX = 0;

    const isCollapsed = localStorage.getItem(storageKey) === 'true';
    if (isCollapsed && container) {
      container.classList.add('is-collapsed');
      if (closeBtn) {
        closeBtn.dataset.open = 'false';
        closeBtn.querySelector('.cart-drawer-recommendations__close-icon').textContent = '↑';
        closeBtn.title = 'Abrir';
        closeBtn.setAttribute('aria-label', 'Abrir recomendaciones');
      }
    } else if (container) {
      container.classList.remove('is-collapsed');
      if (closeBtn) {
        closeBtn.dataset.open = 'true';
        closeBtn.querySelector('.cart-drawer-recommendations__close-icon').textContent = '✕';
        closeBtn.title = 'Cerrar';
        closeBtn.setAttribute('aria-label', 'Cerrar recomendaciones');
      }
    }

    if (closeBtn) {
      const closeBtnListener = (e) => {
        e.preventDefault();
        container.classList.toggle('is-collapsed');
        const isNowCollapsed = container.classList.contains('is-collapsed');
        localStorage.setItem(storageKey, isNowCollapsed);
        
        const icon = closeBtn.querySelector('.cart-drawer-recommendations__close-icon');
        if (isNowCollapsed) {
          closeBtn.dataset.open = 'false';
          icon.textContent = '↑';
          closeBtn.title = 'Abrir';
          closeBtn.setAttribute('aria-label', 'Abrir recomendaciones');
        } else {
          closeBtn.dataset.open = 'true';
          icon.textContent = '✕';
          closeBtn.title = 'Cerrar';
          closeBtn.setAttribute('aria-label', 'Cerrar recomendaciones');
        }
      };
      closeBtn.addEventListener('click', closeBtnListener);
      eventListenersMap.set('closeBtn', closeBtnListener);
    }

    if (prevBtn) {
      const prevBtnListener = () => {
        const itemWidth = carousel.querySelector('.cart-drawer-recommendations__product-item').offsetWidth;
        const gap = 12;
        carousel.scrollBy({
          left: -(itemWidth + gap),
          behavior: 'smooth',
        });
      };
      prevBtn.addEventListener('click', prevBtnListener);
      eventListenersMap.set('prevBtn', prevBtnListener);
    }

    if (nextBtn) {
      const nextBtnListener = () => {
        const itemWidth = carousel.querySelector('.cart-drawer-recommendations__product-item').offsetWidth;
        const gap = 12;
        carousel.scrollBy({
          left: itemWidth + gap,
          behavior: 'smooth',
        });
      };
      nextBtn.addEventListener('click', nextBtnListener);
      eventListenersMap.set('nextBtn', nextBtnListener);
    }

    const touchstartListener = (e) => {
      startX = e.touches[0].clientX;
    };
    const touchendListener = (e) => {
      endX = e.changedTouches[0].clientX;
      const swipeDistance = startX - endX;
      const minSwipeDistance = 50;

      if (Math.abs(swipeDistance) > minSwipeDistance) {
        const itemWidth = carousel.querySelector('.cart-drawer-recommendations__product-item').offsetWidth;
        const gap = 12;
        
        if (swipeDistance > 0) {
          carousel.scrollBy({
            left: itemWidth + gap,
            behavior: 'smooth',
          });
        } else {
          carousel.scrollBy({
            left: -(itemWidth + gap),
            behavior: 'smooth',
          });
        }
      }
    };
    carousel.addEventListener('touchstart', touchstartListener, { passive: true });
    carousel.addEventListener('touchend', touchendListener, { passive: true });
    eventListenersMap.set('carouselTouchstart', touchstartListener);
    eventListenersMap.set('carouselTouchend', touchendListener);
  }

  document.addEventListener('recommendations:reinit', (e) => {
    initRecommendations();
  });

  window.CartDrawerRecommendationsInit = initRecommendations;

  document.addEventListener('click', async (e) => {
    const button = e.target.closest('.cart-drawer-recommendations__button');
    if (!button) return;

    e.preventDefault();
    const variantId = button.dataset.variantId;
    const form = button.closest('.cart-drawer-recommendations__add-to-cart');
    const productId = form.dataset.productId;

    try {
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Agregando...';

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantId),
              quantity: 1,
            },
          ],
        }),
      });

      if (!response.ok) {
        throw new Error('Error al agregar al carrito');
      }

      const cart = await response.json();

      const event = new CustomEvent('cart:update', {
        detail: {
          resource: cart,
          sourceId: 'cart-drawer-recommendations',
          data: {
            source: 'cart-drawer-recommendations',
            productId: productId,
            variantId: variantId,
            itemCount: cart.item_count,
          },
        },
        bubbles: true,
      });
      document.dispatchEvent(event);

      button.textContent = '¡Agregado!';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    } catch (error) {
      console.error('Error al agregar al carrito:', error);
      button.textContent = 'Error al agregar';
      button.disabled = false;
      setTimeout(() => {
        button.textContent = 'Agregar al carrito';
      }, 2000);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations);
  } else {
    initRecommendations();
  }
})();
